import React from 'react';

import Button from '../../../components/ui/Button';

const CalendarHeader = ({ 
  currentDate, 
  view, 
  onViewChange, 
  onNavigate, 
  language,
  onTodayClick 
}) => {
  const viewOptions = [
    { value: 'month', labelEn: 'Month', labelFr: 'Mois', labelAr: 'شهر' },
    { value: 'week', labelEn: 'Week', labelFr: 'Semaine', labelAr: 'أسبوع' },
    { value: 'day', labelEn: 'Day', labelFr: 'Jour', labelAr: 'يوم' }
  ];

  const getLabel = (option) => {
    if (language === 'fr') return option?.labelFr;
    if (language === 'ar') return option?.labelAr;
    return option?.labelEn;
  };

  const todayLabel = {
    en: 'Today',
    fr: "Aujourd\'hui",
    ar: 'اليوم'
  };

  const formatDate = () => {
    const options = { year: 'numeric', month: 'long' };
    if (view === 'day') {
      options.day = 'numeric';
    }
    
    const locale = language === 'fr' ? 'fr-MA' : language === 'ar' ? 'ar-MA' : 'en-US';
    return currentDate?.toLocaleDateString(locale, options);
  };

  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-6">
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="icon"
            onClick={() => onNavigate('prev')}
            iconName="ChevronLeft"
            iconSize={20}
          />
          <Button
            variant="outline"
            size="icon"
            onClick={() => onNavigate('next')}
            iconName="ChevronRight"
            iconSize={20}
          />
        </div>
        <h2 className="text-xl md:text-2xl font-semibold text-foreground">
          {formatDate()}
        </h2>
      </div>
      <div className="flex items-center gap-3 w-full sm:w-auto">
        <Button
          variant="outline"
          onClick={onTodayClick}
          className="flex-1 sm:flex-none"
        >
          {todayLabel?.[language]}
        </Button>

        <div className="flex items-center gap-1 bg-muted rounded-lg p-1">
          {viewOptions?.map((option) => (
            <button
              key={option?.value}
              onClick={() => onViewChange(option?.value)}
              className={`px-3 py-2 rounded-md text-sm font-medium transition-all duration-250 ${
                view === option?.value
                  ? 'bg-primary text-primary-foreground shadow-sm'
                  : 'text-muted-foreground hover:text-foreground'
              }`}
            >
              {getLabel(option)}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CalendarHeader;